import {
	SHOW_LOADING,
	GET_NAME_SPACE,
	LOAD_NAME_SPACE,
	UPDATE_NAME_SPACE,
	GET_TEMPLATES,
	SAVE_TEMPLATE,
	CREATE_TEMPLATE,
	GET_BRAND_STYLE,
	PUT_BRAND_STYLE,
	SAVE_BRAND_STYLE,
	GET_WHATSAPP_ADMIN_NUMBERS,
	SAVE_WHATSAPP_ADMIN_NUMBERS,
	POST_WHATSAPP_ADMIN_NUMBERS,
	SAVE_CHANNEL_WHATSAPP_NUMBERS,
	SAVE_WHATSAPP_MESSENGER_SETTINGS,
	RESET_CHANNELS,
	BRAND_STYLE_UPDATING,
	SAVE_WHATSAPP_NUMBER_METRICS,
	GET_WHATSAPP_NUMBER_METRICS,
	DELETE_TEMPLATE,
	GET_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS,
	SAVE_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS,
} from "../constants/channel";

const initState = {
	loading: false,
	whatsappNameSpace: null,
	templates: [],
	grouped: [],
	brandStyle: {
		bot_name: "",
		bot_sub_name: "",
		logo: null,
		brand_color: "blue",
	},
	isBrandstyleUpdating: false,
	adminNumbers: [],
	whatsappNumbers: [{}],
	whatsappMessengerSettings: null,
	whatsappNumberMetrics: {},
	whatsappNumberAnalytics: {
		amount: 0,
		quantity: 0,
		url: ""
	}
};

const channel = (state = initState, action) => {
	switch (action.type) {
		case GET_NAME_SPACE:
			return {
				...state,
				loading: false,
			};
		case UPDATE_NAME_SPACE:
			return {
				...state,
				loading: false,
			};
		case LOAD_NAME_SPACE:
			return {
				...state,
				loading: false,
				whatsappNameSpace: action.payload,
			};
		case DELETE_TEMPLATE:
			return {
				...state,
				loading: false,
			};
		case CREATE_TEMPLATE:
			return {
				...state,
				loading: false,
			};
		case SAVE_TEMPLATE:
			return {
				...state,
				loading: false,
				templates: [...action.payload.templates],
				grouped: [...action.payload.grouped]
			};
		case GET_TEMPLATES:
			return {
				...state,
				loading: false,
			};
		case SHOW_LOADING: {
			return {
				...state,
				loading: true,
			};
		}
		case GET_BRAND_STYLE: {
			return {
				...state,
				loading: true,
			};
		}
		case PUT_BRAND_STYLE: {
			return {
				...state,
				loading: true,
			};
		}
		case SAVE_BRAND_STYLE: {
			return {
				...state,
				loading: false,
				brandStyle: { ...action.payload },
			};
		}
		case RESET_CHANNELS: {
			return {
				loading: false,
				whatsappNameSpace: null,
				templates: [],
				brandStyle: {
					bot_name: "",
					bot_sub_name: "",
					logo: null,
					brand_color: "blue",
				},
				adminNumbers: [],
				whatsappNumbers: [{}],
				whatsappMessengerSettings: null,
				whatsappNumberMetrics: {},
				grouped: []
			};
		}
		case GET_WHATSAPP_ADMIN_NUMBERS: {
			return {
				...state,
				loading: true,
			};
		}
		case SAVE_WHATSAPP_ADMIN_NUMBERS: {
			return {
				...state,
				loading: true,
				adminNumbers: [...action.payload],
			};
		}
		case POST_WHATSAPP_ADMIN_NUMBERS: {
			return {
				...state,
				loading: true,
			};
		}
		case SAVE_CHANNEL_WHATSAPP_NUMBERS: {
			return {
				...state,
				whatsappNumbers: [...action.payload],
			};
		}
		case SAVE_WHATSAPP_MESSENGER_SETTINGS: {
			return {
				...state,
				whatsappMessengerSettings: action.payload,
			};
		}
		case BRAND_STYLE_UPDATING: {
			return {
				...state,
				isBrandstyleUpdating: action.payload
			};
		}
		case SAVE_WHATSAPP_NUMBER_METRICS: {
			return {
				...state,
				whatsappNumberMetrics: { ...action.payload }
			}
		}
		case GET_WHATSAPP_NUMBER_METRICS: {
			return {
				...state
			}
		}
		case GET_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS: {
			return {
				...state,
			}
		}
		case SAVE_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS: {
			return {
				...state,
				whatsappNumberAnalytics: {
					...state.whatsappNumberAnalytics,
					...action.payload
				}
			}
		}
		default:
			return state;
	}
};

export default channel;
